import { AiCoach_Action as AiCoachAction, AiCoach_Mode as AiCoachMode } from '__generated__/graphql-types';

export const CoachAction = AiCoachAction;
export const CoachMode = AiCoachMode;
